var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33337 6.66659C6.96518 6.66659 6.66671 6.96506 6.66671 7.33325V13.3333C6.66671 13.7014 6.96518 13.9999 7.33337 13.9999H13.3334C13.7016 13.9999 14 13.7014 14 13.3333V7.33325C14 6.96506 13.7016 6.66659 13.3334 6.66659H7.33337ZM5.33337 7.33325C5.33337 6.22868 6.2288 5.33325 7.33337 5.33325H13.3334C14.4379 5.33325 15.3334 6.22868 15.3334 7.33325V13.3333C15.3334 14.4378 14.4379 15.3333 13.3334 15.3333H7.33337C6.2288 15.3333 5.33337 14.4378 5.33337 13.3333V7.33325Z",
    fill: "#60666E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66663 2.00008C2.48981 2.00008 2.32025 2.07032 2.19522 2.19534C2.0702 2.32037 1.99996 2.48994 1.99996 2.66675V8.66675C1.99996 8.84356 2.0702 9.01313 2.19522 9.13815C2.32025 9.26318 2.48982 9.33341 2.66663 9.33341H3.33329C3.70148 9.33341 3.99996 9.63189 3.99996 10.0001C3.99996 10.3683 3.70148 10.6667 3.33329 10.6667H2.66663C2.13619 10.6667 1.62748 10.456 1.25241 10.081C0.87734 9.70589 0.666626 9.19718 0.666626 8.66675V2.66675C0.666626 2.13632 0.87734 1.62761 1.25241 1.25253C1.62749 0.877462 2.13619 0.666748 2.66663 0.666748H8.66663C9.19706 0.666748 9.70577 0.877462 10.0808 1.25253C10.4559 1.62761 10.6666 2.13631 10.6666 2.66675V3.33341C10.6666 3.7016 10.3681 4.00008 9.99996 4.00008C9.63177 4.00008 9.33329 3.7016 9.33329 3.33341V2.66675C9.33329 2.48994 9.26305 2.32037 9.13803 2.19534C9.01301 2.07032 8.84344 2.00008 8.66663 2.00008H2.66663Z",
    fill: "#60666E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/copy.7742f8e569d17c0de59fc89eee046a14.svg";